import ui from './vi/ui.json';

export type UiKey = keyof typeof ui;

const strings: Record<string, string> = { ...ui };

/** Lazily loaded chunks bring their own strings so they stay out of the core bundle. */
export function registerStrings(extra: Readonly<Record<string, string>>): void {
  Object.assign(strings, extra);
}

export function t(key: UiKey | (string & {}), vars?: Record<string, string | number>): string {
  const template = strings[key] ?? key;
  if (!vars) return template;
  return template.replace(/\{(\w+)\}/g, (_, name: string) => {
    const v = vars[name];
    return v === undefined ? `{${name}}` : String(v);
  });
}

export function formatNumber(n: number): string {
  return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}

export function loadBannedWords() {
  return import('./vi/banned-words.json').then((m) => m.default);
}
